/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LpInspectionControllerIsCompleteLp1$Params {
  childId: string;
}

export function lpInspectionControllerIsCompleteLp1(http: HttpClient, rootUrl: string, params: LpInspectionControllerIsCompleteLp1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionControllerIsCompleteLp1.PATH, 'get');
  if (params) {
    rb.path('childId', params.childId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

lpInspectionControllerIsCompleteLp1.PATH = '/api/lp-inspection/complete-LP1/{childId}';
